import React from 'react';

import EmployeeForm from '../shared/EmployeeForm';

const AddEmployee: React.FC<unknown> = () => {
  return <EmployeeForm />;
};

export default AddEmployee;
